.toast-notification {
    display: flex;
    align-items: start;
    justify-content: space-between;
    padding: 16px 8px 16px 16px;
    border-radius: 4px;
    background-color: var(--white);
    box-shadow:
        10px 16px 40px rgba(0, 0, 0, 0.06),
        8px -4px 40px rgba(0, 0, 0, 0.08);
    border-left: 4px solid;
    width: 340px;
    margin-top: 20px;
    overflow: hidden;
    cursor: pointer;
}

.toast-notification--on-animate-in {
    animation: toast-notification-in 600ms var(--custom-easing) 1s forwards;
    transform: translateX(340px);
    opacity: 0;
}

.toast-notification--on-animate-out {
    animation: toast-notification-out 400ms var(--custom-easing) 0s forwards;
    pointer-events: none;
}

.toast-notification--success {
    border-color: var(--green);
}

.toast-notification--error {
    border-color: var(--rose-dk);
}

.toast-notification--warning {
    border-color: var(--orange);
}

.toast-notification--info {
    border-color: var(--blue);
}

.toast-notification--neutral {
    border-color: var(--grey);
}
@keyframes toast-notification-in {
    0% {
        transform: translateX(340px);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes toast-notification-out {
    0% {
        opacity: 1;
        max-height: var(--toast-notification-height);
        margin-top: 20px;
        padding-top: 16px;
        padding-bottom: 16px;
        border-left-width: 4px;
    }

    100% {
        opacity: 0;
        max-height: 0;
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        border-left-width: 0;
    }
}
